import { useEffect } from "react";
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

const StackedBarChart = ({ data }) => {
    const GHG = [];
    const GHG_data = [];
    const water = [];
    const water_data = [];
    const waste = [];
    const waste_data = [];
    const energy = [];
    const energy_data = [];
    data.values.length > 0 ?? data.values.forEach((val) => {
        GHG.push(Object.values(val.Emission))
        water.push(Object.values(val.Water))
        waste.push(Object.values(val.Waste))
        energy.push(Object.values(val.Energy))

    });

    for (let i = 0; GHG.length > 0 ?? i < GHG[0].length; i++) {

        GHG_data.push([GHG[0][i], GHG[1][i], GHG[2][i]]);
        water_data.push([water[0][i], water[1][i], water[2][i]]);
        waste_data.push([waste[0][i], waste[1][i], waste[2][i]]);
        energy_data.push([energy[0][i], energy[1][i], energy[2][i]]);
    }

    useEffect(() => {

        const createStackedBarChart = (chartId, labels, label, dataset1, dataset2, dataset3, backgroundColor, chartName) => {
            const existingChart = Chart.getChart(chartId);

            if (existingChart) {
                existingChart.destroy();
            }
            const stackedBarChartDataset = {
                labels: labels,
                datasets: [
                    {
                        label: label[0],
                        data: dataset1,
                        backgroundColor: backgroundColor[0],
                    },
                    {
                        label: label[1] ? label[1] : "",
                        data: dataset2,
                        backgroundColor: backgroundColor[1],
                    },
                    {
                        label: label[2] ? label[2] : "",
                        data: dataset3,
                        backgroundColor: backgroundColor[2],
                    },
                ],
            };

            const stackedBarChartOptions = {
                responsive: true,
                aspectRatio: 1.4,
                scales: {
                    x: {
                        stacked: true,
                    },
                    y: {
                        stacked: true,
                        beginAtZero: true,
                        ticks: {
                            callback: function (value, index, values) {
                                if (value >= 1000000) {
                                    return (value / 1000000).toFixed(1) + 'M';
                                } else if (value >= 1000) {
                                    return (value / 1000).toFixed(1) + 'K';
                                } else {
                                    return value;
                                }
                            },
                        },
                    },
                },
                plugins: {
                    legend: {
                        labels: {
                            boxWidth: 12,
                            padding: 10,
                        }
                    },
                    datalabels: {
                        color: 'white',
                        anchor: 'center',
                        align: 'center',
                        formatter: (value) => {
                            return value;
                        },
                        font: {
                            weight: 'bold',
                            size: 9,
                        },
                    },
                },
            };

            const stackedBarChartCtx = document.getElementById(chartId).getContext('2d');
            new Chart(stackedBarChartCtx, {
                type: 'bar',
                data: stackedBarChartDataset,
                options: stackedBarChartOptions,
                plugins: [ChartDataLabels],
            });

            const chartNameElement = document.createElement('div');
            chartNameElement.innerText = chartName;
            chartNameElement.className = 'chart-name';
            const existingChartNameElement = document.querySelector(`#${chartId} ~ .chart-name`);
            if (!existingChartNameElement) {
                document.getElementById(chartId).parentNode.style.textAlign = 'center';
                document.getElementById(chartId).parentNode.appendChild(chartNameElement);
            }
        };

        const labels = ['2020', '2021', '2022',];

        createStackedBarChart('stackedBarChart1', labels, ['Scope 1', 'Scope 2', 'Scope 3'], GHG_data[0], GHG_data[1], GHG_data[2], ['rgb(56, 142, 60)', 'rgb(129, 199, 132)', 'rgb(200, 230, 201)'], 'Total GHG Emission(mtCo2)');
        createStackedBarChart('stackedBarChart2', labels, ['Withdrawl', 'Discharge', 'Recycle'], water_data[0], water_data[1], water_data[2], ['rgb(21, 101, 192)', 'rgb(33, 150, 243)', 'rgb(187, 222, 251)'], 'Total Water(Gallons)');
        createStackedBarChart('stackedBarChart3', labels, ['Hazardous', 'Non Hazardous', 'Recycled'], waste_data[0], waste_data[1], waste_data[2], ['rgb(183, 28, 28)', 'rgb(244, 67, 54)', 'rgb(244, 199, 195)'], 'Total Waste(Metric Ton)');
        createStackedBarChart('stackedBarChart4', labels, ['Consumed',], energy_data[0], energy_data[1], energy_data[2], ['rgb(255, 193, 7)', 'rgb(255, 255, 255)', 'rgb(255, 255, 255)'], 'Total Energy(KWh)');
    }, [data]);

    return (
        <>
            {[1, 2, 3, 4].map((index) => (
                <div className="col-md-3" key={index}>
                    <canvas id={`stackedBarChart${index}`} className="chart"></canvas>
                </div>
            ))}
        </>
    );
}

export default StackedBarChart